<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import axios from 'axios'

export default {
  page: {
    title: 'Domains registration alarms',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Domains registration alarms',
      category: 'List',
      url: '/domains/registration/alarms?',
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Domains registration alarms',
          active: true,
        },
      ],
      isBusy: false,
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: '',
      sortBy: 'datetime',
      sortDesc: true,
      fields: [
        { key: 'datetime', field: 'datetime', label: 'Alarms', thClass: 'incident-status', sortable: true, visible: true },
        { key: 'domain', field: 'domain', label: 'Domain', sortable: true, visible: true },
        { key: 'range', field: 'range', label: 'Creation Range', sortable: true, visible: true },
        { key: 'whois_creation_datetime', field: 'whois.creation_date', label: 'Domain Creation', thClass: 'incident-status', sortable: true, visible: true },
        { key: 'whois_expiration_datetime', field: 'whois.expiration_date', label: 'Domain Expiration', thClass: 'incident-status', sortable: true, visible: true },
        { key: 'whois_registrar', field: 'whois.registrar', label: 'Whois Registrar', sortable: true, visible: true },
      ],
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required },
    },
  },
  computed: {
    rows() {
      return this.totalRows
    },
    displayedRange() {
      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(start + this.perPage - 1, this.totalRows);
      return { start, end };
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    extractDate(data) {
      // console.log('data keys', Array.keys(data))
      // data = data['$date']
      if (data === undefined) return 'N/A'
      // const keys = Object.keys(data)
      // if (keys.length > 0 && keys.includes('$date')) {
      //   data = data['$date']
      //   console.log('data date', data)
      // }
      // console.log('data keys', Object.keys(data))

      // console.log('data parameter', data)
      if (Array.isArray(data)) {
        console.log('data array', data[0])
        return data[0]['$date']
      } else {
        return data['$date']
      }
    },
    loadData(src = '') {
      let that = this
      that.isBusy = true
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const searchType = this.searchType
      const countURL = (src.length < 1) ? `${baseURL}${that.url}&count=yes` : `${baseURL}${that.url}&${searchType}=${src}&count=yes`

      axios.get(countURL)
        .then((response) => {
          that.totalRows = parseInt(response.data)
        })
        .catch(function () {

        })
      const dataURL = `${baseURL}${that.url}&page=${that.currentPage}&page_size=${that.perPage}&limit=${that.perPage}`
      axios.get(dataURL).then((response) => {
        if (response.status === 200) {
          const format = "yyyy-MM-ddTHH:mm:ss";
          that.tableData = response.data.map(function (entry) {
            return {
              datetime: new Date(entry.datetime).toLocaleString(),
              domain: entry.domain,
              range: `${parseInt(entry.range).toLocaleString()} days`,
              whois_creation_datetime: new Date(that.extractDate(entry.whois.creation_date)).toLocaleString(),
              whois_expiration_datetime: new Date(that.extractDate(entry.whois.expiration_date)).toLocaleString(),
              whois_registrar: entry.whois.registrar,
            }
          })
          console.log('tableData', that.tableData);
        }
        that.isBusy = false
      })
        .catch(function () {

        })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <span>
          Showing {{ displayedRange.start }} to {{ displayedRange.end }} of {{ totalRows }}
        </span>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-table :items="tableData" :fields="fields" :busy="isBusy" responsive="sm" :per-page="0"
              :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :total-rows="totalRows"
              :pagination-options="{
                  enabled: true,
                }">
              <template v-slot:table-busy>
                <div class="text-center">
                  <br><br>
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>&nbsp;&nbsp;Loading...</strong>
                </div>
              </template>
            </b-table>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"
                      @change="loadData"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                      @input="loadData"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
